<template>
  <div id="app">
    <div class="page-header" v-if="showPageHeader" :style='{paddingTop: statusBarHeight + "px"}'>
      <div class="page-header-back">
        <div class="black-icon" @click="goBack"></div>
      </div>
      <div class="page-header-content">{{pageHeader}}</div>
    </div>
    <div class="page-main" ref="pageMain">
      <router-view/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      showPageHeader: !!sessionStorage.getItem('showPageHeader') ? true : false,
      pageHeader: sessionStorage.getItem('pageHeader') || '客服小助手',
      statusBarHeight: sessionStorage.getItem('statusBarHeight') || 20
    }
  },
  mounted(){
  },
  methods: {
    goBack: ()=>{
      window.history.go(-2);
    }
  }
}
</script>

<style lang="scss">
  @import './scss/main.scss';
  *{
    margin: 0;
    padding: 0;
  }
  html,body {
    height: 100%;
  }
  #app {
    display: flex;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    flex-direction: column;
    /*max-width: 1024px;*/
    color: #333;
  }
  .page-header{
    position: relative;
    flex-shrink: 0;
    display: flex;
    height: 44px;
    margin-bottom: 0px;
    background-color: white;
    padding-top: 20px;
    align-items: center;
    justify-content: center;
    .page-header-back{
      position: absolute;
      left: 0;
      width: 44px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      user-select: none;
      .black-icon{
        width: 9px;
        height: 15px;
        background-image: url('./assets/left-arrow.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
      }
    }
    .page-header-content{
      width: calc(100% - 28.26667vw);
      color: #333;
      font-weight: bold;
      font-size: 17px;
      text-align: center;
      user-select: none;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .page-main{
    position: relative;
    flex: 1 1;
    overflow-x: hidden;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue